<template>
  <div id="vstream" class>
    <div id="video" v-html="agorahtml" style="margin:0 auto;height:100%;">
    </div>
    <div class="vdo_col">
      <div class="qlty_vdo">
        <span class="high_vdo active" @click="switchStream(1)">High Quality</span>
        <span class="low_vdo" @click="switchStream(0)">Low Quality</span>
      </div>
    </div>
   <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";


export default {
  name: 'Videostream',
  props: ["connection", `isLiveStatus`, "bus"],

  data() {
    return {
      isActive: true,
      channelid: this.connection.id,
      key: this.connection.key,
      // cli: AgoraRTC.createClient({ mode: "interop" }),
      st: null,
      height: this.connection.height,
      width: this.connection.width,
      playing: false,
      agorahtml: "",
      client: {},
      loading : false,
      color:'#ff3c3c'
    };
  },

  mounted() {
    this.join();
  },

  created() {
    bus.$on("changeLanguage", (channelid = null) => {
      this.leave(channelid);
    });
  },

  methods: {
    streamEvents() {
      var _this = this;
      _this.client.on("error", function(err) {
        if (err.reason === "DYNAMIC_KEY_TIMEOUT") {
          _this.client.renewChannelKey(
            "",
            function() {
            },
            function(err) {
            }
          );
        }
      });

      _this.client.on("stream-added", function(evt) {
        var stream = evt.stream;
        _this.$data.st = evt.stream;
        _this.client.subscribe(stream, function(err) {
        });
      });

      _this.client.on("stream-subscribed", function(evt) {
        var stream = evt.stream;
        this.stream = stream;
        // _this.$data.st=evt.stream;
        let liveStatus = true;
        _this.isLiveStatus(liveStatus);
        if (document.getElementById("agora_remote")) {
          var i = document.getElementById("agora_remote").childElementCount;
          var a = document.getElementById("agora_remote");
          for (var _ = 0; _ < i; _++) {
            var b = a.children[_];
            if (b && b.className != "resize-sensor") {
              a.removeChild(b);
            }
          }
        }
        _this.$data.agorahtml = "";
        var append =
          '<div id="agora_remote" class="video-container" style="float:left; width:' +
          _this.$data.width +
          ";height:" +
          _this.$data.height +
          ';display:inline-block;background:transparent">' +
          "</div>";
        _this.$data.agorahtml = append;

        if ($("div#video #agora_remote").length === 0) {
        }
        setTimeout(function() {
          $($("#agora_remote div")[0]).css({ background: "white" });
          var h = _this.$data.height;
          var w = _this.$data.width;
          $("#agora_remote").css({ height: h, width: w });
          stream.play("agora_remote");
        }, 500);
      });

      _this.client.on("stream-removed", function(evt) {
        var stream = evt.stream;
        let liveStatus = false;
        _this.isLiveStatus(liveStatus);
        _this.$data.st.stop();
        if (stream) {
          stream.stop();
          $("#agora_remote" + stream.getId()).remove();
        }
      });

      _this.client.on("peer-leave", function(evt) {
        var stream = evt.stream;
        let liveStatus = false;
        _this.isLiveStatus(liveStatus);
        _this.$data.st.stop();
        if (stream) {
          stream.stop();
          $("#agora_remote" + stream.getId()).remove();
        }
      });

      
    },
    

    join: function() {
      var _this = this;
      _this.loading = true
      var channel_key = null;
      var localStream, camera, microphone;
      var channelid = _this.channelid;
      _this.client = AgoraRTC.createClient({ mode: "interop" });
      _this.client.init(
        _this.key,
        function() {
          _this.streamEvents();
          _this.client.join(
            channel_key,
            channelid,
            null,            
            function(uid) {
              _this.loading = false
            },
            function(err) {
              console.log("Join channel failed", err);
            }
          );
        },
        function(err) {
          console.log("AgoraRTC client init failed", err);
        }
      );
    },

    leave: function(channelid = null ) {     
      var _this = this;      
      _this.loading = true
        _this.client.leave(function() {
          setTimeout(function(){
            _this.loading = false
            if(channelid !== null) {              
              _this.channelid = channelid
            }
            _this.join();
            
          },2000)      
        });
      
    },

    switchStream: function(highOrLow) {
      $(document).on("click", ".qlty_vdo span", function() {
        $(".qlty_vdo span").removeClass("active");
        $(this).addClass("active");
      });
      var _this = this;
      if (highOrLow === 0) {
        highOrLow = 1;
      } else {
        highOrLow = 0;
      }
      _this.client.setRemoteVideoStreamType(_this.$data.st, highOrLow);
    }
  }
};
</script>
<style scoped>
#vstream {
      position: absolute;
    left: 0;
    width: 100%;
    top: 0;
    height: 100%;
}

.show-on-bottom {
  bottom: 1%;
}
.keep-height-width-zero {
  height: 0px !important;
  width: 0px !important;
}
.show-on-top {
  /*top: 8%;*/
  height: 100vh !important;
  width: 100% !important;
}
.video-container {
  float: left;
  width: 200px;
  height: 200px;
  display: inline-block;
  background: transparent;
}
#agora_remote {
  float: left;
  width: 100%;
  height: 100%;
  display: inline-block;
  background: transparent;
  position: relative;
}
#agora_remote div {
  background: transparent !important;
  background-color: transparent !important;
}
#agora_remote > div {
  background: transparent !important;
  background-color: transparent !important;
}
.vdo_col{
      top: 15px;
}
</style>
